export const defaultOptions = {
  routineCare: [
    { label: 'Include', value: true },
    { label: 'Exclude', value: false }
  ],
  boosterCare: [
    { label: 'Include', value: true },
    { label: 'Exclude', value: false }
  ]
};
